import { Calendar, Edit3 } from "lucide-react";

type Props = {
    name: string;
    taskId: any;
    startDate: string;
    endDate?: string;
    draft?: boolean;
    permanent?: boolean;
    isPermanent?: boolean;
    setCampaignId?: any;
};

const KanbanCard = ({ name, startDate, endDate, draft, taskId, isPermanent, setCampaignId }: Props) => {
    return (
        <div
            className={`p-4 mt-3 bg-white rounded-xl group hover:bg-opacity-100 border-2 mx-3 border-indigo-200 hover:border-indigo-300 shadow-sm hover:shadow-md ${draft && "border-dashed"}`}
            style={{
                cursor: "grab",
                transition: "all 0.3s ease"
            }}
        >
            <div>
                <div className="flex justify-between items-center">
                    <h4 className="text-sm font-medium">
                        {name}
                    </h4>

                    {draft && (
                        <button
                            className="p-0.5 flex items-center justify-center w-5 h-5 text-gray-400 rounded hover:bg-gray-200 hover:text-gray-500 group-hover:flex"
                            onClick={(e) => {
                                e.stopPropagation();
                                setCampaignId(taskId);
                            }}
                        >
                            <Edit3 />
                        </button>
                    )}
                </div>

                {isPermanent && (
                    <span
                        className={`px-2 py-1 mt-2 text-xs font-medium rounded-full border border-indigo-300 text-indigo-500`}
                    >
                        Permanent
                    </span>
                )}

                <div className="flex justify-between w-full mt-3 pt-5 text-xs font-medium text-gray-400">
                    <div className="flex items-center">
                        <Calendar className="w-4 h-4 text-gray-300" />
                        <span className="ml-1 leading-none">{startDate}</span>
                    </div>

                    <div className="flex items-center">
                        <Calendar className="w-4 h-4 text-gray-300" />
                        <span className="ml-1 leading-none">{endDate}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KanbanCard;
